module.exports = __webpack_public_path__ + "static/media/pamain.c3698693.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain.ttf
// module id = ./src/assets/fonts/pamain.ttf
// module chunks = 6